import { Banner } from '@neo4j-ndl/react';
import { MODAL_TYPE, useModal } from '@nx/state';
import { useDesktopV1InfoQuery, useGetUserSettingsQuery, useSetUserSettingsMutation } from '@nx/state/desktop';

import { useHasV1InstanceBeenCloned } from '../local-instance/hooks/use-has-v1-instance-been-cloned';

export function MigrateV1InstancesBanner({ canDismiss, className }: { canDismiss?: boolean; className?: string }) {
  const { data: desktopV1Info } = useDesktopV1InfoQuery();
  const { hasV1InstanceBeenCloned } = useHasV1InstanceBeenCloned();
  const { open } = useModal(MODAL_TYPE.CLONE_DESKTOP_V1_DBMSS);
  const { data: userSettings } = useGetUserSettingsQuery();
  const [setUserSettings] = useSetUserSettingsMutation();
  const instancesNotClonedToV2 = desktopV1Info?.dbmss.filter((dbms) => !hasV1InstanceBeenCloned(dbms.id)) ?? [];

  if (desktopV1Info?.environmentExists !== true || instancesNotClonedToV2.length === 0) {
    return null;
  }

  if (canDismiss === true && userSettings?.dismissedCloneDesktopV1Dbmss === true) {
    return null;
  }

  return (
    <Banner
      className={className}
      hasIcon
      usage="inline"
      title="Detected Neo4j instances from an older Neo4j Desktop installation"
      description={`You have Neo4j instances created with an older version of Neo4j Desktop. Would you like to clone them to the current version of Neo4j Desktop?`}
      actions={
        canDismiss === true
          ? [
              {
                label: 'View and clone',
                fill: 'outlined',
                onClick: () => {
                  void open();
                },
              },
              {
                label: 'Dismiss',
                fill: 'text',
                onClick: () => {
                  void setUserSettings({ dismissedCloneDesktopV1Dbmss: true });
                },
              },
            ]
          : [
              {
                label: 'View and clone',
                fill: 'outlined',
                onClick: () => {
                  void open();
                },
              },
            ]
      }
    />
  );
}
